import { FC } from 'react';
import { LozingenV2 } from '../v2/lozingen-v2';

export const LozingenV4: FC<{ teeltwijze: number }> = ({ teeltwijze }) => <LozingenV2 teeltwijze={teeltwijze} />;
